import _ from 'lodash';
import { useEffect, useState } from 'react';

import { apiRequest } from 'common-src/features/rest';

import useInterval from 'src/hooks/useInterval';

const useEventsLinking = (patientId) => {
  const [awscCalls, setAwscCalls] = useState([]);
  const [videoCalls, setVideoCalls] = useState([]);
  const [clients, setClients] = useState([]);

  const setUniqueClients = (data) => {
    const uniqueClients = _.uniqBy([...clients, ...(data?.Client || [])], 'id');
    setClients(uniqueClients);
  };

  useInterval(() => {
    apiRequest({
      endpoint: `awscCall/latest/${patientId}`,
    })
      .then((res) => res.json())
      .then((data) => {
        setAwscCalls(data?.AwscCall || []);
        setUniqueClients(data);
      });

    apiRequest({
      endpoint: `videoCalls/latest/${patientId}`,
    })
      .then((res) => res.json())
      .then((data) => {
        setVideoCalls(data?.ChimeVideoCall || []);
        setUniqueClients(data);
      });
  }, 20 * 1000); // INFO: poll awsc calls on every 20 seconds

  useEffect(() => {
    apiRequest({
      endpoint: `awscCall/latest/${patientId}`,
    })
      .then((res) => res.json())
      .then((data) => {
        setAwscCalls(data?.AwscCall || []);
        setUniqueClients(data);
      });

    apiRequest({
      endpoint: `videoCalls/latest/${patientId}`,
    })
      .then((res) => res.json())
      .then((data) => {
        setVideoCalls(data?.ChimeVideoCall || []);
        setUniqueClients(data);
      });
  }, []);

  return { awscCalls, clients, videoCalls };
};

export default useEventsLinking;
